// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__Jwa17","cardTitle":"Card_cardTitle__XV2UE","cardInfo":"Card_cardInfo__a2Xzf","cardImg":"Card_cardImg__qwRvc"};